module.exports = __webpack_public_path__ + "static/media/documentation.2e6c903f.md";